<template>
	<b-nav-item class="mx-1 d-md-down-none" to="/messaging" id="messaging-popover">
		<b-avatar button variant="outline-info" size="30px" :badge="badge" badge-variant="danger">
			<i class="fa-light fa-bell fa-lg"></i>
		</b-avatar>
		<b-popover id="notification-popover" ref="popover" placement="bottom" target="messaging-popover" title="Notifications" triggers="hover focus">
			<template v-if="hasNewMessages">
				<b-list-group flush>
					<b-list-group-item v-for="(message, index) in messages" to="/messaging" active-class="" :key="index">
						<b-media>
							<template #aside>
								<span class="text-danger"><i class="fa-solid fa-circle fa-2xs"></i></span>
							</template>
							<div>{{message.message}}</div>
							<div class="text-muted small">{{dynamicDateTime(message.created)}}</div>
						</b-media>
					</b-list-group-item>
				</b-list-group>
			</template>
			<template v-else>
				<b-list-group flush>
					<b-list-group-item active-class="">
						No new messages
					</b-list-group-item>
				</b-list-group>
			</template>
		</b-popover>
	</b-nav-item>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
export default {
	name: 'messaging-navbar-button',
	computed: {
        ...mapGetters('messaging', ['getNavbarMessages']),
        navbar() {
            return this.getNavbarMessages()
        },
		hasNewMessages() {
			return this.navbar?.length > 0
		},
		badge() {
			return this.hasNewMessages ? String(this.navbar.length) : false
		},
		messages() {
			return this.hasNewMessages ? this.navbar.slice(0, 5) : []
		}
	},
	methods: {
		...mapActions('messaging', ['getNavBar']),
		async handleSocket(payload) {
			if (payload.action === "notify") {
				if (payload.username === this.user?.username) {
					await this.getNavBar()
				}
			}
		}
	},
	async mounted() {
		await this.getNavBar()

        EventBus.$on('messaging-socket', payload => {
            this.handleSocket(payload)
        }) 
	},
	beforeDestroy() {
		EventBus.$off('messaging-socket')
	},	
}
</script>
<style>
#notification-popover .popover-body {
	padding: 0 !important;
}
</style>